module.exports = __webpack_public_path__ + "static/media/flutter.1d00a9dc.PNG";